// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1enLe","alert":"SettungsInbox_alert__1oCsE"};